<template>
  <div class="content">   
 
    </div>    
  
</template>
<script>



  import axios from 'axios';
  import $ from 'jquery';

export default {
  components: {
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
    // a computed getter
    tableDataComputed: function () {
    }
  },
  methods: {
  },
  created() {
    $.ajaxSetup({
      data: {
        'sessionId': this.$store.getters.sessionId,
      },
    });
    var self= this
    var request = $.ajax({
      url: "https://"+window.location.hostname+":8085/CRM/controller/mailjet.php",
      async: false,
      type: "POST",
      data: {
        'test':1
      },
      dataType: "html",
      success: function(data) { 
      }
    })


  }
}
</script>
<style>
</style>
